import { Leaderboard, LeaderboardType, Transaction } from '@repo/database/src/types';

import { PayoutStructure } from './payout-structure-types';

export enum LeaderboardStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  ARCHIVED = 'ARCHIVED',
  CANCELLED = 'CANCELLED',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  PAYING_OUT = 'PAYING_OUT',
  RESEEDING = 'RESEEDING',
  UPCOMING = 'UPCOMING',
}

export interface LeaderboardPrizeWinner {
  alias: string;
  prize: number;
}

export interface LeaderboardRanking {
  user: {
    userId: string;
    alias: string;
  } | null;
  rakeAmount: number | null;
  points: number | null;
  reward?: number | null;
  yesterdaysRanking: number | null;
  rank: number | null;
  self?: boolean;
}

export interface LeaderboardState {
  leaderboardBalance: number | null;
  reseedAmount: number;
  rankings: LeaderboardRanking[];
  prizeTierStructure: number[];
}

export interface LeaderboardStats {
  id: string | null;
  startDate: Date | null;
  endDate: Date | null;
  rankings: LeaderboardRanking[];
  leaderboardBalance: number | null;
  minRakeQualifierAmount: number;
  status: LeaderboardStatus;
  prizeTierStructure: number[];
}

export interface ActiveLeaderboard {
  current: LeaderboardStats | null;
  previous: LeaderboardStats | null;
}

export interface ActiveLeaderboardOverview {
  [LeaderboardType.MICRO]: ActiveLeaderboard;
  [LeaderboardType.MEDIUM]: ActiveLeaderboard;
  [LeaderboardType.HIGH]: ActiveLeaderboard;
}

export interface LeaderboardPayout extends LeaderboardRanking {
  transaction: Transaction | null;
}

export interface LeaderboardDetails {
  id: string;
  status: string;
  startDate: Date;
  endDate: Date | null;
  currentReseedAmount: number;
  totalBalance: number;
  minRakeQualifierAmount: number;
  minReseedAmount: number;
  reseedPercentage: number;
  payoutStructure: PayoutStructure;
  type: LeaderboardType | null;
  maxBigBet: number | null;
  minBigBet: number | null;
  maxBigBlind: number | null;
  minBigBlind: number | null;
}

export interface LeaderboardOverview {
  [LeaderboardType.MICRO]: LeaderboardDetails;
  [LeaderboardType.MEDIUM]: LeaderboardDetails;
  [LeaderboardType.HIGH]: LeaderboardDetails;
}

export type UpdateLeaderboardConfigBody = Partial<Leaderboard> & Pick<Leaderboard, 'id'>;

export const GRIND_PRIX_LEADERBOARD = 'Grind Prix';
